var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.705 4.265a1 1 0 0 0-1.708.718c0 .268.105.525.293.717l3.65 3.85a1.5 1.5 0 0 0 2.12 0l3.645-3.85a1.001 1.001 0 0 0 0-1.435 1 1 0 0 0-1.41 0L9 6.765V1a1 1 0 0 0-2 0v5.745l-2.295-2.48ZM2 14h12V9a1 1 0 0 1 2 0v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V9a1 1 0 0 1 2 0v5Z"
  })));
};
export default SvgDownload;